import FranceProfessionalCategory from 'modules/contracts/store/models/FranceProfessionalCategory'

import { PayrollLegalEntityResource } from '../payrollLegalEntityResource'

class ProfessionalCategories extends PayrollLegalEntityResource<FranceProfessionalCategory> {
  get cacheKey(): string {
    return 'franceProfessionalCategories'
  }

  model() {
    return FranceProfessionalCategory
  }
}

export { ProfessionalCategories }
